const notifications = {
  apiClient: null,
  path: '/admin/notifications',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getAll(category = null, beforeId = null) {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (beforeId) params.append('before_id', beforeId);
    const query = params.toString();
    const response = await this.apiClient.get(query ? `${this.path}?${query}` : this.path);
    return response.data;
  },

  async confirm(id) {
    const response = await this.apiClient.put(`${this.path}/${id}/confirm`);
    return response.data;
  },

  async confirmAll() {
    const response = await this.apiClient.put(`${this.path}/confirm`);
    return response.data;
  },

  async destroy(id) {
    const response = await this.apiClient.delete(`${this.path}/${id}`);
    return response.data;
  },

  async clear({ category = null, scope = 'read' } = {}) {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (scope) params.append('scope', scope);
    const response = await this.apiClient.delete(`${this.path}/clear?${params.toString()}`);
    return response.data;
  },
};

export default notifications;
